import styled from "@emotion/styled";
import { css } from "@emotion/react";
import TableCell from "./cell";
import Icon from "components/icon";
import { Colors } from "theme/colors";

export const StyledIconCell = styled(TableCell)`
  cursor: default;
  text-align: center;
`;

interface IconProps {
  $disabled: boolean;
}

export const StyledIcon = styled(Icon)<IconProps>`
  cursor: pointer;
  color: ${Colors.PURPLE};
  &:hover {
    color: ${Colors.LIGHT_PURPLE};
  }

  ${(props) =>
    props.$disabled &&
    css`
      pointer-events: none;
      cursor: default;
      color: ${Colors.DARK_GRAY};
      &:hover {
        color: ${Colors.DARK_GRAY};
      }
    `}
`;
